import { render, staticRenderFns } from "./PolizasIEForm.vue?vue&type=template&id=3423200a&scoped=true&"
import script from "./PolizasIEForm.vue?vue&type=script&lang=js&"
export * from "./PolizasIEForm.vue?vue&type=script&lang=js&"
import style0 from "./PolizasIEForm.vue?vue&type=style&index=0&id=3423200a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423200a",
  null
  
)

export default component.exports